import { Record } from 'immutable'

export interface ICriticalDateContact {
  contactId: string
  emailAddress?: string
  isCompany: boolean
  name: string
}

const CriticalDateContactRecord = Record({
  contactId: '',
  emailAddress: undefined,
  isCompany: false,
  name: '',
})

export class CriticalDateContact extends CriticalDateContactRecord
  implements ICriticalDateContact {
  public static fromJS(initialState?: Partial<ICriticalDateContact>) {
    return new CriticalDateContact(initialState)
  }

  public readonly contactId: string
  public readonly emailAddress?: string
  public readonly isCompany: boolean
  public readonly name: string

  constructor(initialState?: Partial<CriticalDateContact>) {
    initialState ? super(initialState) : super()
  }
}
